function Stars({ count = 5 }) {
  return (
    <div className="flex items-center gap-[3px]">
      {[...Array(5)].map((_, i) => (
        <svg
          key={i}
          className={`w-[11px] h-[11px] flex-shrink-0 ${i < count ? "text-gold" : "text-t-dim"}`}
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ))}
    </div>
  );
}

function TCard({ name, text, featured, delay }) {
  return (
    <div
      className={[
        "relative flex flex-col gap-3.5 rounded-[14px] p-[clamp(18px,2vw,26px)] overflow-hidden",
        "border transition-all duration-300 hover:-translate-y-[3px] hover:shadow-[0_14px_36px_rgba(8,24,40,.5)]",
        "hover:border-[rgba(109,211,167,.25)] anim-up",
        featured
          ? "border-[rgba(109,211,167,.22)] bg-gradient-to-br from-[#0E2540] to-[#0A1E34]"
          : "border-[rgba(109,211,167,0.11)] bg-[#0C1F35]",
      ].join(" ")}
      style={{ animationDelay: `${delay}s` }}
    >
      {/* featured top gradient bar */}
      {featured && (
        <span
          className="absolute top-0 left-0 right-0 h-[2px]"
          style={{ background: "linear-gradient(90deg,#6DD3A7,#F2B949)" }}
        />
      )}

      {/* large quote mark watermark */}
      <span
        className="absolute -top-[10px] left-4 font-cairo font-black text-[7rem] leading-none text-mint opacity-[.05] pointer-events-none select-none"
        aria-hidden="true"
      >
        "
      </span>

      {/* name */}
      <div className="flex items-center justify-between">
        <span
          className="font-cairo font-extrabold text-mint tracking-tight"
          style={{
            fontSize: "clamp(.9rem,1.1vw,1rem)",
            letterSpacing: "-.01em",
          }}
        >
          {name}
        </span>
      </div>

      <Stars />

      <p
        className="text-t-sec leading-[1.85] flex-1"
        style={{ fontSize: "clamp(.82rem,.88rem,.92rem)" }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
}

const TESTIMONIALS = [
  {
    name: "فيصل بخرجي",
    featured: true,
    delay: 0.08,
    text: 'أكبر مشكلة عندي كانت الخبرة — كل وظيفة تطلب خبرة وأنا خريج. <em style="font-style:normal;color:#F7F2E9;font-weight:500">بس الورش اللي حضرتها مع آفاق علمتني مهارات مطلوبة</em> وهذا خلاني أتكلم بثقة أكثر في المقابلات وحصلت على وظيفتي الأولى بفضل الله.',
  },
  {
    name: "عبدالله الحربي",
    delay: 0.14,
    text: 'كنت خريج نظم معلومات ما لقيت وظيفة لسنة. <em style="font-style:normal;color:#F7F2E9;font-weight:500">دخلت في Cyber وحصلت على وظيفة SOC Analyst خلال شهرين.</em>',
  },
  {
    name: "هوازن الحربي",
    delay: 0.2,
    text: 'كنت أشتغل كثير لكن ما كنت حاسة أني أتطور. بعد انضمامي في آفاق والمرشدين <em style="font-style:normal;color:#F7F2E9;font-weight:500">خلوني أراجع طريقة شغلي وأشوف فين نقاط الضعف</em> ومع الوقت بدأت أحس أن عندي تحكم أكبر في مساري المهني.',
  },
  {
    name: "حنين الكيال",
    delay: 0.26,
    text: 'الدعم كان موجود كل الوقت. التاسكات العملية أكثر من النظرية، العمل الجماعي المختلف، الـ case study، ونوعية البرامج من لقاءات إلى أبحاث ومقالات. <em style="font-style:normal;color:#F7F2E9;font-weight:500">دعم المدربات كان جداً واضح وملموس — تجربتي مع آفاق كانت مميزة.</em>',
  },
  {
    name: "غيداء السيد",
    delay: 0.31,
    text: 'المشرفين كانوا جداً متعاونين. اعجبني أن التدريب كل يوم له موضوع مختلف — <em style="font-style:normal;color:#F7F2E9;font-weight:500">نبدع ونتعلم ونطبق، وفكرة أبطال الأسبوع كانت تطور مهارة القيادة عندنا.</em> كل أسبوع نستعرض أعمالنا وهذا ساعدني أحسّن مهاراتي الإلقائية.',
  },
  {
    name: "عايد المدرع",
    delay: 0.36,
    text: 'مواضيع التدريب تتحدث باستمرار وأسلوب التدريب كان فعّال ويحاكي الوظائف. <em style="font-style:normal;color:#F7F2E9;font-weight:500">بعد ما توظفت لاحظت أن تدريب آفاق يحاكي العمل الحقيقي في الشركات بشكل كبير.</em>',
  },
];

const TICKER_ITEMS = [
  {
    name: "صالحة المالكي",
    quote:
      "بعد آفاق صار عندي تصور أوضح عن الأشياء اللي ممكن تفيدني فعلاً في شغلي",
  },
  {
    name: "سارة العتيبي",
    quote: "خرجت بمشروع ذكاء بيانات حقيقي وعرض عمل من جهة حكومية في الرياض",
  },
  {
    name: "فيصل الزهراني",
    quote: "آفاق تخلينا نغلط ونجرب ونتعلم ونتقن — وهذا اللي يحتاجه السوق",
  },
  {
    name: "محمد الحسن",
    quote: "سويت أول ملف أعمال مع آفاق وقدرت أحول معرفتي لخبرة",
  },
];

export default function Testimonials() {
  // duplicate for seamless loop
  const tickerItems = [...TICKER_ITEMS, ...TICKER_ITEMS];

  return (
    <section
      className="relative overflow-hidden px-[clamp(16px,5vw,80px)] py-[clamp(64px,9vh,110px)]"
      id="testimonials"
    >
      {/* top divider */}
      <div
        className="absolute top-0 left-[clamp(16px,5vw,80px)] right-[clamp(16px,5vw,80px)] h-px"
        style={{
          background:
            "linear-gradient(90deg,transparent,rgba(109,211,167,0.11) 30%,rgba(109,211,167,0.11) 70%,transparent)",
        }}
      />
      {/* bg glows */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 60% 40% at 20% 50%,rgba(109,211,167,0.04) 0%,transparent 70%),radial-gradient(ellipse 50% 40% at 80% 20%,rgba(242,185,73,0.03) 0%,transparent 60%)",
        }}
      />

      {/* ── Header ── */}
      <div
        className="text-center mb-[clamp(40px,5.5vh,64px)] relative z-[2] anim-up"
        style={{ animationDelay: ".05s" }}
      >
        <span className="inline-flex items-center gap-2 font-mono text-[.68rem] tracking-[.2em] uppercase text-mint font-semibold mb-[1.2rem] before:content-['◆'] before:text-[.4rem] before:opacity-40 after:content-['◆'] after:text-[.4rem] after:opacity-40">
          PASSENGER REVIEWS · آراء المسافرين
        </span>
        <h2
          className="font-cairo font-black leading-[1.1] tracking-tight text-t-primary mb-[.6rem]"
          style={{ fontSize: "clamp(1.9rem,3.5vw,3.1rem)" }}
        >
          ما قالوه بعد أن <em className="not-italic text-mint">هبطوا</em>
        </h2>
        <p className="text-[.93rem] text-t-sec leading-[1.85] max-w-[460px] mx-auto">
          هذه تجارب حقيقية من متدربين أكملوا الرحلة — بكلماتهم، بدون تحرير.
        </p>
      </div>

      {/* ── 3×2 Grid ── */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[clamp(10px,1.2vw,16px)] mb-[clamp(32px,4vh,48px)] relative z-[2]">
        {TESTIMONIALS.map((t) => (
          <TCard key={t.name} {...t} />
        ))}
      </div>

      {/* ── Ticker ── */}
      <div
        className="relative z-[2] overflow-hidden border-t border-b border-[rgba(109,211,167,0.11)] py-[18px] bg-[rgba(8,24,40,.3)] mb-[clamp(32px,4vh,48px)] anim-up"
        style={{ animationDelay: ".4s" }}
      >
        {/* label pill on the right (RTL = visually right side) */}
        <div className="absolute right-0 top-0 bottom-0 flex items-center px-5 bg-ink-mid border-l border-[rgba(109,211,167,0.11)] z-[3]">
          <span className="font-mono text-[.55rem] tracking-[.14em] uppercase text-mint font-bold whitespace-nowrap">
            آراء إضافية ◆
          </span>
        </div>

        {/* scrolling track */}
        <div
          className="flex items-center w-max"
          style={{
            animation: "ticker 32s linear infinite",
            paddingRight: "160px",
          }}
        >
          {tickerItems.map((item, i) => (
            <div key={i} className="flex items-center">
              <div className="flex items-center gap-3 px-[clamp(24px,3vw,40px)] flex-shrink-0">
                <span className="font-cairo font-bold text-mint text-[.82rem] whitespace-nowrap">
                  {item.name}
                </span>
                <span className="text-[.5rem] text-t-dim">◆</span>
                <span className="text-[.78rem] text-t-sec whitespace-nowrap">
                  {item.quote}
                </span>
              </div>
              <span className="w-1 h-1 rounded-full bg-t-dim flex-shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
